export const idlFactory = ({ IDL }) => {
  const CollectionData = IDL.Record({
    'controller' : IDL.Principal,
    'metadata' : IDL.Text,
    'name' : IDL.Text,
    'canister_id' : IDL.Principal,
    'created_at' : IDL.Nat64,
    'cycle_balance' : IDL.Nat64,
  });
  const LinkedWallets = IDL.Record({
    'sui_addresses' : IDL.Vec(IDL.Text),
    'evm_addresses' : IDL.Vec(IDL.Text),
    'solana_pubkeys' : IDL.Vec(IDL.Text),
  });
  const UserProfile = IDL.Record({
    'bio' : IDL.Opt(IDL.Text),
    'user_principal' : IDL.Principal,
    'updated_at' : IDL.Nat64,
    'name' : IDL.Opt(IDL.Text),
    'payout_currency' : IDL.Opt(IDL.Text),
    'created_at' : IDL.Nat64,
    'preferences' : IDL.Opt(IDL.Text),
    'oisy_wallet' : IDL.Opt(IDL.Principal),
    'linked_wallets' : LinkedWallets,
  });
  const WalletLinkChallenge = IDL.Record({
    'issued_at' : IDL.Nat64,
    'kind' : IDL.Text,
    'message' : IDL.Text,
    'nonce' : IDL.Text,
    'expires_at' : IDL.Nat64,
  });
  return IDL.Service({
    'add_collection' : IDL.Func(
        [IDL.Principal, IDL.Principal, IDL.Text, IDL.Text],
        [IDL.Text],
        [],
      ),
    'confirm_link_wallet' : IDL.Func(
        [IDL.Text, IDL.Text, IDL.Text, IDL.Text],
        [IDL.Text],
        [],
      ),
    'create_profile' : IDL.Func(
        [IDL.Text, IDL.Opt(IDL.Text), IDL.Opt(IDL.Text)],
        [IDL.Text],
        [],
      ),
    'get_blob' : IDL.Func(
        [IDL.Principal, IDL.Text],
        [IDL.Opt(IDL.Vec(IDL.Nat8))],
        [],
      ),
    'get_collections' : IDL.Func(
        [IDL.Principal],
        [IDL.Vec(CollectionData)],
        [],
      ),
    'get_linked_wallets' : IDL.Func(
        [IDL.Principal],
        [IDL.Opt(LinkedWallets)],
        [],
      ),
    'get_oisy_wallet' : IDL.Func([IDL.Principal], [IDL.Opt(IDL.Principal)], []),
    'get_payout_currency' : IDL.Func([IDL.Principal], [IDL.Opt(IDL.Text)], []),
    'get_profile' : IDL.Func([IDL.Principal], [IDL.Opt(UserProfile)], []),
    'list_blobs' : IDL.Func([IDL.Principal], [IDL.Vec(IDL.Text)], []),
    'set_oisy_wallet' : IDL.Func([IDL.Principal], [IDL.Text], []),
    'set_payout_currency' : IDL.Func([IDL.Text], [IDL.Text], []),
    'start_link_wallet' : IDL.Func([IDL.Text], [WalletLinkChallenge], []),
    'store_blob' : IDL.Func(
        [IDL.Principal, IDL.Text, IDL.Vec(IDL.Nat8)],
        [IDL.Text],
        [],
      ),
    'update_collection_cycles' : IDL.Func(
        [IDL.Principal, IDL.Nat64],
        [IDL.Text],
        [],
      ),
    'update_profile' : IDL.Func(
        [IDL.Text, IDL.Opt(IDL.Text), IDL.Opt(IDL.Text)],
        [IDL.Text],
        [],
      ),
  });
};
export const init = ({ IDL }) => { return []; };
